var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2343 4.41107C16.5597 4.73651 16.5597 5.26414 16.2343 5.58958L11.5009 10.3229L16.2343 15.0563C16.5597 15.3817 16.5597 15.9093 16.2343 16.2348C15.9088 16.5602 15.3812 16.5602 15.0557 16.2348L10.3224 11.5014L5.58909 16.2347C5.26366 16.5602 4.73602 16.5602 4.41058 16.2347C4.08514 15.9093 4.08514 15.3817 4.41058 15.0562L9.1439 10.3229L4.41058 5.5896C4.08514 5.26416 4.08514 4.73653 4.41058 4.41109C4.73602 4.08565 5.26366 4.08565 5.58909 4.41109L10.3224 9.14441L15.0557 4.41107C15.3812 4.08563 15.9088 4.08563 16.2343 4.41107Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/Close X.6ddc4289196780a520d56708e37cd510.svg";
export { ForwardRef as ReactComponent };